export const taskCenter = {
    syrw: "Görevlerle başlar, sizinle biter",
    zjlbt: "Biking USDT hediyelerini almaya devam edin",
    wdjj: "Ödüllerim",
    rwsm: "Görev açıklaması",
    rwlb: "Görev listesi",
    jljl: "Ödül kaydı",
    klq: "Alınabilir",
    flzm: "Biking avantaj kapısı",
    dcjl: "Başarınca alın, USDT ödülleri yol boyunca size eşlik eder",
    yjlq: "Tek tıkla al",
    lqcg: "Başarıyla alındı",
    wdl: "Giriş yapılmadı",
    jxz: "Devam ediyor",
    ylq: "Zaten alındı",
    rwjd: "Görev ilerlemesi",
    xsrw: "Yeni başlayan görevleri",
    hyrw: "Sözleşme görevleri",
    cjrz: "Temel kimlik doğrulama",
    gjrz: "Gelişmiş kimlik doğrulama",
    scbbjy: "İlk para ticareti",
    schyjy: "İlk sözleşme ticareti",
    sccz: "İlk yükleme",
    schyhz: "İlk sözleşme transferi",
    jyl: "İşlem hacmi",
    ylje: "Kar miktarı",
    ksje: "Kayıp miktarı",
    dbkcbzj: "Tek işlem açma teminatı",
    rjl: "Yatırılan miktar",
    dbczje: "Tek seferlik yükleme miktarı",
    rwxq: "Görev ayrıntıları"
}


// WEBPACK FOOTER //
// ./src/i18n/lang/task/tr.js